"use client";

import React, { useState } from "react";
import EnqueryForm from "@/components/forms/EnqueryForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";

const benefits = [
  "Unlimited access to: masterclasses, podcasts, reels, webinars, and AI Challenges",
  "Learn anywhere: desktop, mobile, even offline",
  "Become a Certified AI-Ready Accountant (CAIRA)",
  "Earn NASBA-approved CPE credits, tracked for you",
  "Earn Credly badges that turn heads on LinkedIn",
];

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    className="shrink-0 mt-0.5"
  >
    <path
      d="M5 13l4 4L19 7"
      stroke="#FFBA08"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PriceCard = () => (
  <div className="gcc-border relative rounded-[10px] border border-white/[0.06] bg-[#1D1D1D] px-6 py-8 md:py-12 text-center">
    <p className="text-white text-sm md:text-sm">
      Go From AI-Curious to AI-Ready at
    </p>
    <p className="mt-2 flex items-baseline justify-center gap-2">
      <span className="text-white text-[34px] md:text-[34px] font-bold leading-none">
        ₹89,000
      </span>
      {/* <span className="text-[#8A8A8A] text-lg line-through">$999</span> */}
    </p>
  </div>
);

const Benefits = () => (
  <ul className="space-y-3 md:space-y-4">
    {benefits.map((b) => (
      <li
        key={b}
        className="flex gap-2.5 text-white text-xs md:text-sm leading-snug"
      >
        <CheckIcon />
        <span>{b}</span>
      </li>
    ))}
  </ul>
);

const CairaPricing = ({ hideForms = false }: { hideForms?: boolean }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleGetStarted = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

  return (
    <section className="w-full bg-black py-7 md:py-[50px]">
      <div className="main_container mx-auto px-4 md:px-6 md:max-w-[1280px]">
        {/* Title */}
        <div className="text-center mb-6 md:mb-10">
          <h2 className="text-[22px] md:text-[30px] font-bold text-[#FFBA08] leading-tight">
            Pricing &amp; Upgrade Path
          </h2>
          <p className="text-white text-sm md:text-base font-semibold mt-1">
            One-time investment. Lifetime AI advantage
          </p>
        </div>

        {/* Mobile: price card first, then benefits. Desktop: benefits left, price card right */}
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-12 md:w-[1000px] justify-center mx-auto">
          <div className="order-1 md:order-2 md:w-1/2">
            <PriceCard />
          </div>
          <div className="order-2 md:order-1 md:w-1/2">
            <Benefits />
          </div>
        </div>

        {/* CTA */}
        {!hideForms && (
          <div className="flex justify-center mt-6 md:mt-10">
            <button
              type="button"
              onClick={handleGetStarted}
              className="w-full md:w-[260px] rounded-[8px] bg-[#3399FF] hover:bg-[#3b7ce6] transition-colors text-white font-bold text-sm py-2.5 md:py-2 text-center"
            >
              Get Started
            </button>
          </div>
        )}
      </div>

      {!hideForms && isFormOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] px-4">
          <div
            className="relative p-6 w-full md:w-[430px] rounded-2xl border"
            style={{
              background: "rgba(33, 100, 167, 0.10)",
              boxShadow: "0 0 54.9px 0 rgba(166, 137, 255, 0.30) inset",
              borderColor: "rgba(255, 255, 255, 0.06)",
              backdropFilter: "blur(8px)",
            }}
          >
            <button
              type="button"
              onClick={closeForm}
              className="absolute right-2 top-0 text-white px-3 py-1 rounded"
            >
              ✕
            </button>
            <EnqueryForm
              course="CAIRA"
              courseId={1}
              formHeading={FormHeading.TALK_TO_CAIRA_ADVISOR}
              formType="page"
              isAStepperForm
              subCategory={FinanceAndAccountingSubcategory.CPA}
              submitButtonName="Enroll Now"
              successMessage={SuccessMessageType.ACCOUNTING}
              verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
              darkBackground
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default CairaPricing;
